/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  IntegrationConfig,
  IntegrationConfigRequest,
  IntegrationsConfigsListParams,
  MaintenanceRequest,
  PaginatedIntegrationConfigList,
  PatchedIntegrationConfigRequest,
  Provider
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type integrationsConfigsListResponse200 = {
  data: PaginatedIntegrationConfigList
  status: 200
}
    
export type integrationsConfigsListResponseSuccess = (integrationsConfigsListResponse200) & {
  headers: Headers;
};
;

export type integrationsConfigsListResponse = (integrationsConfigsListResponseSuccess)

export const getIntegrationsConfigsListUrl = (params?: IntegrationsConfigsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/integrations/configs/?${stringifiedParams}` : `/api/v1/integrations/configs/`
}

export const integrationsConfigsList = async (params?: IntegrationsConfigsListParams, options?: RequestInit): Promise<integrationsConfigsListResponse> => {
  
  return apiFetch<integrationsConfigsListResponse>(getIntegrationsConfigsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getIntegrationsConfigsListQueryKey = (params?: IntegrationsConfigsListParams,) => {
    return [
    `/api/v1/integrations/configs/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getIntegrationsConfigsListQueryOptions = <TData = Awaited<ReturnType<typeof integrationsConfigsList>>, TError = unknown>(params?: IntegrationsConfigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIntegrationsConfigsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationsConfigsList>>> = ({ signal }) => integrationsConfigsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IntegrationsConfigsListQueryResult = NonNullable<Awaited<ReturnType<typeof integrationsConfigsList>>>
export type IntegrationsConfigsListQueryError = unknown


export function useIntegrationsConfigsList<TData = Awaited<ReturnType<typeof integrationsConfigsList>>, TError = unknown>(
 params: undefined |  IntegrationsConfigsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationsConfigsList>>,
          TError,
          Awaited<ReturnType<typeof integrationsConfigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIntegrationsConfigsList<TData = Awaited<ReturnType<typeof integrationsConfigsList>>, TError = unknown>(
 params?: IntegrationsConfigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationsConfigsList>>,
          TError,
          Awaited<ReturnType<typeof integrationsConfigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIntegrationsConfigsList<TData = Awaited<ReturnType<typeof integrationsConfigsList>>, TError = unknown>(
 params?: IntegrationsConfigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIntegrationsConfigsList<TData = Awaited<ReturnType<typeof integrationsConfigsList>>, TError = unknown>(
 params?: IntegrationsConfigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIntegrationsConfigsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type integrationsConfigsCreateResponse201 = {
  data: IntegrationConfig
  status: 201
}
    
export type integrationsConfigsCreateResponseSuccess = (integrationsConfigsCreateResponse201) & {
  headers: Headers;
};
;

export type integrationsConfigsCreateResponse = (integrationsConfigsCreateResponseSuccess)

export const getIntegrationsConfigsCreateUrl = () => {


  

  return `/api/v1/integrations/configs/`
}

export const integrationsConfigsCreate = async (integrationConfigRequest: IntegrationConfigRequest, options?: RequestInit): Promise<integrationsConfigsCreateResponse> => {
  
  return apiFetch<integrationsConfigsCreateResponse>(getIntegrationsConfigsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      integrationConfigRequest,)
  }
);}




export const getIntegrationsConfigsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsCreate>>, TError,{data: IntegrationConfigRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsCreate>>, TError,{data: IntegrationConfigRequest}, TContext> => {

const mutationKey = ['integrationsConfigsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof integrationsConfigsCreate>>, {data: IntegrationConfigRequest}> = (props) => {
          const {data} = props ?? {};

          return  integrationsConfigsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IntegrationsConfigsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof integrationsConfigsCreate>>>
    export type IntegrationsConfigsCreateMutationBody = IntegrationConfigRequest
    export type IntegrationsConfigsCreateMutationError = unknown

    export const useIntegrationsConfigsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsCreate>>, TError,{data: IntegrationConfigRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof integrationsConfigsCreate>>,
        TError,
        {data: IntegrationConfigRequest},
        TContext
      > => {

      const mutationOptions = getIntegrationsConfigsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type integrationsConfigsRetrieveResponse200 = {
  data: IntegrationConfig
  status: 200
}
    
export type integrationsConfigsRetrieveResponseSuccess = (integrationsConfigsRetrieveResponse200) & {
  headers: Headers;
};
;

export type integrationsConfigsRetrieveResponse = (integrationsConfigsRetrieveResponseSuccess)

export const getIntegrationsConfigsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/integrations/configs/${id}/`
}

export const integrationsConfigsRetrieve = async (id: string, options?: RequestInit): Promise<integrationsConfigsRetrieveResponse> => {
  
  return apiFetch<integrationsConfigsRetrieveResponse>(getIntegrationsConfigsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getIntegrationsConfigsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/integrations/configs/${id}/`
    ] as const;
    }

    
export const getIntegrationsConfigsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof integrationsConfigsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIntegrationsConfigsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationsConfigsRetrieve>>> = ({ signal }) => integrationsConfigsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IntegrationsConfigsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof integrationsConfigsRetrieve>>>
export type IntegrationsConfigsRetrieveQueryError = unknown


export function useIntegrationsConfigsRetrieve<TData = Awaited<ReturnType<typeof integrationsConfigsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationsConfigsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof integrationsConfigsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIntegrationsConfigsRetrieve<TData = Awaited<ReturnType<typeof integrationsConfigsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationsConfigsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof integrationsConfigsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIntegrationsConfigsRetrieve<TData = Awaited<ReturnType<typeof integrationsConfigsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIntegrationsConfigsRetrieve<TData = Awaited<ReturnType<typeof integrationsConfigsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsConfigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIntegrationsConfigsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type integrationsConfigsUpdateResponse200 = {
  data: IntegrationConfig
  status: 200
}
    
export type integrationsConfigsUpdateResponseSuccess = (integrationsConfigsUpdateResponse200) & {
  headers: Headers;
};
;

export type integrationsConfigsUpdateResponse = (integrationsConfigsUpdateResponseSuccess)

export const getIntegrationsConfigsUpdateUrl = (id: string,) => {


  

  return `/api/v1/integrations/configs/${id}/`
}

export const integrationsConfigsUpdate = async (id: string,
    integrationConfigRequest: IntegrationConfigRequest, options?: RequestInit): Promise<integrationsConfigsUpdateResponse> => {
  
  return apiFetch<integrationsConfigsUpdateResponse>(getIntegrationsConfigsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      integrationConfigRequest,)
  }
);}




export const getIntegrationsConfigsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsUpdate>>, TError,{id: string;data: IntegrationConfigRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsUpdate>>, TError,{id: string;data: IntegrationConfigRequest}, TContext> => {

const mutationKey = ['integrationsConfigsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof integrationsConfigsUpdate>>, {id: string;data: IntegrationConfigRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  integrationsConfigsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IntegrationsConfigsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof integrationsConfigsUpdate>>>
    export type IntegrationsConfigsUpdateMutationBody = IntegrationConfigRequest
    export type IntegrationsConfigsUpdateMutationError = unknown

    export const useIntegrationsConfigsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsUpdate>>, TError,{id: string;data: IntegrationConfigRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof integrationsConfigsUpdate>>,
        TError,
        {id: string;data: IntegrationConfigRequest},
        TContext
      > => {

      const mutationOptions = getIntegrationsConfigsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type integrationsConfigsPartialUpdateResponse200 = {
  data: IntegrationConfig
  status: 200
}
    
export type integrationsConfigsPartialUpdateResponseSuccess = (integrationsConfigsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type integrationsConfigsPartialUpdateResponse = (integrationsConfigsPartialUpdateResponseSuccess)

export const getIntegrationsConfigsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/integrations/configs/${id}/`
}

export const integrationsConfigsPartialUpdate = async (id: string,
    patchedIntegrationConfigRequest: PatchedIntegrationConfigRequest, options?: RequestInit): Promise<integrationsConfigsPartialUpdateResponse> => {
  
  return apiFetch<integrationsConfigsPartialUpdateResponse>(getIntegrationsConfigsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedIntegrationConfigRequest,)
  }
);}




export const getIntegrationsConfigsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsPartialUpdate>>, TError,{id: string;data: PatchedIntegrationConfigRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsPartialUpdate>>, TError,{id: string;data: PatchedIntegrationConfigRequest}, TContext> => {

const mutationKey = ['integrationsConfigsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof integrationsConfigsPartialUpdate>>, {id: string;data: PatchedIntegrationConfigRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  integrationsConfigsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IntegrationsConfigsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof integrationsConfigsPartialUpdate>>>
    export type IntegrationsConfigsPartialUpdateMutationBody = PatchedIntegrationConfigRequest
    export type IntegrationsConfigsPartialUpdateMutationError = unknown

    export const useIntegrationsConfigsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsPartialUpdate>>, TError,{id: string;data: PatchedIntegrationConfigRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof integrationsConfigsPartialUpdate>>,
        TError,
        {id: string;data: PatchedIntegrationConfigRequest},
        TContext
      > => {

      const mutationOptions = getIntegrationsConfigsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type integrationsConfigsDestroyResponse204 = {
  data: void
  status: 204
}
    
export type integrationsConfigsDestroyResponseSuccess = (integrationsConfigsDestroyResponse204) & {
  headers: Headers;
};
;

export type integrationsConfigsDestroyResponse = (integrationsConfigsDestroyResponseSuccess)

export const getIntegrationsConfigsDestroyUrl = (id: string,) => {


  

  return `/api/v1/integrations/configs/${id}/`
}

export const integrationsConfigsDestroy = async (id: string, options?: RequestInit): Promise<integrationsConfigsDestroyResponse> => {
  
  return apiFetch<integrationsConfigsDestroyResponse>(getIntegrationsConfigsDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getIntegrationsConfigsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['integrationsConfigsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof integrationsConfigsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  integrationsConfigsDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IntegrationsConfigsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof integrationsConfigsDestroy>>>
    
    export type IntegrationsConfigsDestroyMutationError = unknown

    export const useIntegrationsConfigsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof integrationsConfigsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getIntegrationsConfigsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-132: force a payment provider « in maintenance » (its fallback is offered at once)
or mark it restored (the payers who asked are told by e-mail). Audited.
 */
export type integrationsConfigsMaintenanceCreateResponse200 = {
  data: IntegrationConfig
  status: 200
}
    
export type integrationsConfigsMaintenanceCreateResponseSuccess = (integrationsConfigsMaintenanceCreateResponse200) & {
  headers: Headers;
};
;

export type integrationsConfigsMaintenanceCreateResponse = (integrationsConfigsMaintenanceCreateResponseSuccess)

export const getIntegrationsConfigsMaintenanceCreateUrl = (id: string,) => {


  

  return `/api/v1/integrations/configs/${id}/maintenance/`
}

export const integrationsConfigsMaintenanceCreate = async (id: string,
    maintenanceRequest: MaintenanceRequest, options?: RequestInit): Promise<integrationsConfigsMaintenanceCreateResponse> => {
  
  return apiFetch<integrationsConfigsMaintenanceCreateResponse>(getIntegrationsConfigsMaintenanceCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      maintenanceRequest,)
  }
);}




export const getIntegrationsConfigsMaintenanceCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsMaintenanceCreate>>, TError,{id: string;data: MaintenanceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsMaintenanceCreate>>, TError,{id: string;data: MaintenanceRequest}, TContext> => {

const mutationKey = ['integrationsConfigsMaintenanceCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof integrationsConfigsMaintenanceCreate>>, {id: string;data: MaintenanceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  integrationsConfigsMaintenanceCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IntegrationsConfigsMaintenanceCreateMutationResult = NonNullable<Awaited<ReturnType<typeof integrationsConfigsMaintenanceCreate>>>
    export type IntegrationsConfigsMaintenanceCreateMutationBody = MaintenanceRequest
    export type IntegrationsConfigsMaintenanceCreateMutationError = unknown

    export const useIntegrationsConfigsMaintenanceCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsMaintenanceCreate>>, TError,{id: string;data: MaintenanceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof integrationsConfigsMaintenanceCreate>>,
        TError,
        {id: string;data: MaintenanceRequest},
        TContext
      > => {

      const mutationOptions = getIntegrationsConfigsMaintenanceCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Tester la connexion » button (short, synchronous, 10 s timeout: D-017).
 */
export type integrationsConfigsTestCreateResponse200 = {
  data: IntegrationConfig
  status: 200
}
    
export type integrationsConfigsTestCreateResponseSuccess = (integrationsConfigsTestCreateResponse200) & {
  headers: Headers;
};
;

export type integrationsConfigsTestCreateResponse = (integrationsConfigsTestCreateResponseSuccess)

export const getIntegrationsConfigsTestCreateUrl = (id: string,) => {


  

  return `/api/v1/integrations/configs/${id}/test/`
}

export const integrationsConfigsTestCreate = async (id: string, options?: RequestInit): Promise<integrationsConfigsTestCreateResponse> => {
  
  return apiFetch<integrationsConfigsTestCreateResponse>(getIntegrationsConfigsTestCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getIntegrationsConfigsTestCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsTestCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsTestCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['integrationsConfigsTestCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof integrationsConfigsTestCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  integrationsConfigsTestCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IntegrationsConfigsTestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof integrationsConfigsTestCreate>>>
    
    export type IntegrationsConfigsTestCreateMutationError = unknown

    export const useIntegrationsConfigsTestCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationsConfigsTestCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof integrationsConfigsTestCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getIntegrationsConfigsTestCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Catalogue of providers and their fields: the screens build their forms from it (D-018).
 */
export type integrationsProvidersListResponse200 = {
  data: Provider[]
  status: 200
}
    
export type integrationsProvidersListResponseSuccess = (integrationsProvidersListResponse200) & {
  headers: Headers;
};
;

export type integrationsProvidersListResponse = (integrationsProvidersListResponseSuccess)

export const getIntegrationsProvidersListUrl = () => {


  

  return `/api/v1/integrations/providers/`
}

export const integrationsProvidersList = async ( options?: RequestInit): Promise<integrationsProvidersListResponse> => {
  
  return apiFetch<integrationsProvidersListResponse>(getIntegrationsProvidersListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getIntegrationsProvidersListQueryKey = () => {
    return [
    `/api/v1/integrations/providers/`
    ] as const;
    }

    
export const getIntegrationsProvidersListQueryOptions = <TData = Awaited<ReturnType<typeof integrationsProvidersList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsProvidersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIntegrationsProvidersListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationsProvidersList>>> = ({ signal }) => integrationsProvidersList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof integrationsProvidersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IntegrationsProvidersListQueryResult = NonNullable<Awaited<ReturnType<typeof integrationsProvidersList>>>
export type IntegrationsProvidersListQueryError = unknown


export function useIntegrationsProvidersList<TData = Awaited<ReturnType<typeof integrationsProvidersList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsProvidersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationsProvidersList>>,
          TError,
          Awaited<ReturnType<typeof integrationsProvidersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIntegrationsProvidersList<TData = Awaited<ReturnType<typeof integrationsProvidersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsProvidersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationsProvidersList>>,
          TError,
          Awaited<ReturnType<typeof integrationsProvidersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIntegrationsProvidersList<TData = Awaited<ReturnType<typeof integrationsProvidersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsProvidersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIntegrationsProvidersList<TData = Awaited<ReturnType<typeof integrationsProvidersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof integrationsProvidersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIntegrationsProvidersListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




